import wrapWithProvider from "./wrap-with-provider";
export const wrapRootElement = wrapWithProvider;


export const onInitialClientRender = () => {
  if (!document.getElementById("trustarc-script")) {
    const script = document.createElement("script");
    script.id = "trustarc-script";
    script.src = "//consent.trustarc.com/notice?domain=cm-nationwide.com&c=teconsent&js=nj&noticeType=bb&text=true&pcookie&gtm=1";
    script.setAttribute("crossorigin", "anonymous");
    script.async = true;
    document.head.appendChild(script);
  }
};

